import { SagaIterator } from "redux-saga";
import { select } from "redux-saga/effects";

import { ReportType } from "constants/reports/report-type";
import { ApiManager } from "services/api";
import { selectFeatureTogglePerformanceReport } from "store/entities/license";
import { Plan, selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { IActionWithPayload } from "store/helper";

import { IFetchReportPayload } from "../interfaces";

import { makeFetchingSaga } from "./helpers";

export function* fetchSolvedClosedTickets(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  const isTeam = yield select(state => selectCurrentSubscriptionPlan(state) === Plan.Team);
  const hasPerformanceReport = yield select(selectFeatureTogglePerformanceReport);
  const requests = [
    {
      name: "solvedTickets",
      interface: ApiManager.reportApi.fetchSolvedTickets,
    },
    {
      name: "closedTickets",
      interface: ApiManager.reportApi.fetchClosedTickets,
    },
  ];
  if (hasPerformanceReport) {
    requests.push(
      {
        name: "solvedTicketsPerTeam",
        interface: ApiManager.reportApi.fetchSolvedTicketsPerTeam,
      },
      {
        name: "closedTicketsPerTeam",
        interface: ApiManager.reportApi.fetchClosedTicketsPerTeam,
      }
    );
    if (!isTeam) {
      requests.push(
        {
          name: "solvedTicketsPerAgent",
          interface: ApiManager.reportApi.fetchSolvedTicketsPerAgent,
        },
        {
          name: "closedTicketsPerAgent",
          interface: ApiManager.reportApi.fetchClosedTicketsPerAgent,
        }
      );
    }
  }
  // @ts-expect-error TS(2345): Argument of type '{ name: string; interface: any; ... Remove this comment to see the full error message
  yield makeFetchingSaga(ReportType.SolvedAndClosed, action, requests);
}
